export default __webpack_public_path__ + "static/media/Asset5_H2_Bus.38e30abc.jpeg";